<mat-toolbar color="primary">
    <span>Protocole</span>
    <span class="toolbar-spacer"></span>
    <div class="toolbar-upload">
        <angular-file-uploader #scanUpload
            [config]="afuConfig"
            (ApiResponse)="certificateUpload($event)">
        </angular-file-uploader>
    </div>
    <button mat-icon-button style="margin-top: 9px;">
        <fa-icon (click)="ocr()" [icon]="['fas','book-spells']" size="2x"></fa-icon>
    </button>
    <button mat-icon-button style="margin-top: 9px;">
        <fa-icon (click)="save()" [icon]="['fas','save']" size="2x"></fa-icon>
    </button>
</mat-toolbar>
<div style="height:80vh;overflow-y: scroll;width:calc(80vw - 50px);">
    <div class="protocol-description">
        <ckeditor 
        [editor]="editor"
        [(ngModel)]="protocol.value" 
        [config]="editorConfig"
        (change)="editorContentChange($event)"
        ></ckeditor>
        <!-- <mat-form-field class="field-full-width">
            <mat-label>Description</mat-label>
            
            <textarea [(ngModel)]="protocol.value" matInput style="min-height: 10em;"></textarea>
        </mat-form-field> -->
    </div>
    <div fxLayout="row" class="protocol-documents">
        <div fxFlex class="protocol-documents-left">
            <div *ngFor="let document of documents" class="protocol-document">
                <img src="{{document.file}}">
            </div>
        </div>
        <div fxFlex="200px" class="protocol-documents-right">
            <div *ngFor="let thumbnail of thumbnails" class="protocol-thumbnail">
                <img src="{{thumbnail}}">
            </div>
        </div>
    </div>
</div>